import { createStyles, rem } from '@mantine/core'

export interface StylesParams {
  showFullSlide?: boolean
  gapMobile?: number
  gapDesktop?: number
  withIndicators?: boolean
}

export default createStyles(
  (
    theme,
    { showFullSlide, gapMobile, gapDesktop, withIndicators }: StylesParams,
  ) => {
    return {
      wrapper: {
        display: 'flex',
        flexDirection: 'column',
        gap: rem(12),
      },
      sliderWrapper: {
        '& > *': {
          height: '100%',
        },
      },
      listing: {
        display: 'flex',
        gap: rem(gapMobile),
        alignItems: 'stretch',
        [theme.fn.largerThan('sm')]: {
          gap: rem(gapDesktop),
        },
      },
      itemWrapper: {
        flex: '1 1 0px',
        '& > *': {
          height: '100%',
        },
      },
      carouselRoot: {},
      carouselViewport: {},
      carouselIndicators: {
        position: 'static',
        marginTop: '24px',
      },
      carouselIndicator: {
        width: 8,
        height: 8,
        borderRadius: '50%',
        border: `1px solid ${theme.colors.neutral100}`,
        boxShadow: 'none',
        background: '#fff',
        opacity: 1,
        '&[data-active]': {
          borderColor: theme.fn.primaryColor(),
          background: theme.fn.primaryColor(),
        },
      },
      progressBar: {
        background: theme.colors.neutral[3],
      },
      progressRoot: {
        marginTop: rem(20),
        backgroundColor: theme.colors.neutral[1],
        [theme.fn.smallerThan('sm')]: {
          ...(!showFullSlide && {
            marginRight: rem(16),
          }),
        },
      },
      arrow: {
        ...(withIndicators && {
          marginTop: -16,
        }),
      },
      arrowPrev: {},
      arrowNext: {},
      arrowIcon: {},
    }
  },
)
